<div class="flex items-center justify-center px-4 py-8 lg:py-12">
  <div
    class="w-full max-w-lg p-10 rounded-2xl shadow-sm border border-gray-50 text-center space-y-8"
  >
    <div class="space-y-3">
      <h1 class="text-3xl font-semibold text-[#0D3543]">
        {{ 'auth.emailVerification.title' | translate }}
      </h1>
      <p class="text-gray-500 text-sm font-normal">
        {{ 'auth.emailVerification.description' | translate }}
        <span class="font-bold text-[#0D3543]" dir="ltr">{{ email }}</span>
      </p>
    </div>

    @if (errorMessage()) {
      <div
        class="p-3 rounded-lg bg-red-50 text-red-700 text-sm border border-red-200"
      >
        {{ errorMessage() }}
      </div>
    }

    <form (ngSubmit)="onVerify()">
      <div class="flex justify-center gap-3 md:gap-4 py-4" dir="ltr">
        @for (item of otpArray; track $index) {
          <div class="w-10 h-10 md:w-16 md:h-16">
            <input
              type="text"
              maxlength="1"
              inputmode="numeric"
              [attr.autocomplete]="$index === 0 ? 'one-time-code' : 'off'"
              [ngModel]="otpArray[$index]"
              [ngModelOptions]="{ standalone: true }"
              (input)="onInput($event, $index)"
              (paste)="onPaste($event, $index)"
              (keydown)="onKeyDown($event, $index)"
              class="w-full h-full text-center text-xl font-semibold border border-[#E7E8EB] rounded focus:border-[#2596BE] focus:ring-2 focus:ring-[#2596BE]/10 outline-none transition-all text-[#0D3543]"
            />
          </div>
        }
      </div>

      <button
        type="submit"
        [disabled]="isLoading()"
        class="w-full flex justify-center items-center gap-2 bg-[#2596BE] hover:bg-[#1a7a9c] disabled:bg-gray-400 disabled:cursor-not-allowed text-white py-3 rounded-lg transition-all"
      >
        @if (isLoading()) {
          <span class="loading loading-spinner loading-sm"></span>
        } @else {
          {{ 'auth.emailVerification.verifyAndProceed' | translate }}
        }
      </button>
    </form>

    <!-- <div class="text-xs text-[#0D3543] flex items-center justify-center gap-1">
      {{ 'auth.emailVerification.didntReceiveCode' | translate }}
      <button class="text-[#2596BE] hover:underline">{{ 'auth.emailVerification.resendCode' | translate }}</button>
      <span class="text-[#EF1E1E] ml-1">{{ timer() }}</span>
    </div> -->
  </div>
</div>
